module.exports = __webpack_public_path__ + "static/media/edit-icon1.b657f30d.svg";